.Stats {
  margin: 20px 0;
  padding: 8px;
  border: 1px solid #555;
}
.Stats-item {
  margin: 8px 0;
}



/** WEBPACK FOOTER **
 ** ./~/less-loader!./src/Stats.less
 **/